"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Custom = void 0;
var Custom = /** @class */ (function () {
    function Custom(window) {
        this.ADD_TO_CART_EVENT = '';
        this.ORDER_CREATED_EVENT = '';
        this.window = window;
    }
    Custom.prototype.getCart = function () {
        return {
            currency: '',
            id: '',
            items: [],
            subtotal: 0
        };
    };
    Custom.prototype.getOrder = function () {
        return {
            isCompleted: false
        };
    };
    Custom.prototype.extractCartFromEvent = function (e) {
        return {
            currency: '',
            id: '',
            items: [],
            subtotal: 0
        };
    };
    Custom.prototype.extractOrderFromEvent = function (e) {
        return {
            isCompleted: false
        };
    };
    Custom.prototype.registerEvents = function (checkAndDispatchCartEvent, checkAndDispatchOrderEvent) {
        this.window.addEventListener(this.ADD_TO_CART_EVENT, checkAndDispatchCartEvent);
        this.window.addEventListener(this.ORDER_CREATED_EVENT, checkAndDispatchOrderEvent);
    };
    return Custom;
}());
exports.Custom = Custom;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9tLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvZWNvbW1lcmNlL3BsYXRmb3Jtc01hbmFnZXJzL0N1c3RvbS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQTtJQU1JLGdCQUFhLE1BQWM7UUFMM0Isc0JBQWlCLEdBQUcsRUFBRSxDQUFBO1FBQ3RCLHdCQUFtQixHQUFHLEVBQUUsQ0FBQTtRQUtwQixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtJQUN4QixDQUFDO0lBRUQsd0JBQU8sR0FBUDtRQUNJLE9BQU87WUFDSCxRQUFRLEVBQUUsRUFBRTtZQUNaLEVBQUUsRUFBRSxFQUFFO1lBQ04sS0FBSyxFQUFFLEVBQUU7WUFDVCxRQUFRLEVBQUUsQ0FBQztTQUNkLENBQUE7SUFDTCxDQUFDO0lBRUQseUJBQVEsR0FBUjtRQUNJLE9BQU87WUFDSCxXQUFXLEVBQUUsS0FBSztTQUNyQixDQUFBO0lBQ0wsQ0FBQztJQUVELHFDQUFvQixHQUFwQixVQUFzQixDQUFTO1FBQzNCLE9BQU87WUFDSCxRQUFRLEVBQUUsRUFBRTtZQUNaLEVBQUUsRUFBRSxFQUFFO1lBQ04sS0FBSyxFQUFFLEVBQUU7WUFDVCxRQUFRLEVBQUUsQ0FBQztTQUNkLENBQUE7SUFDTCxDQUFDO0lBRUQsc0NBQXFCLEdBQXJCLFVBQXVCLENBQVM7UUFDNUIsT0FBTztZQUNILFdBQVcsRUFBRSxLQUFLO1NBQ3JCLENBQUE7SUFDTCxDQUFDO0lBRUQsK0JBQWMsR0FBZCxVQUFnQix5QkFBOEIsRUFBRSwwQkFBK0I7UUFDM0UsSUFBSSxDQUFDLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsaUJBQWlCLEVBQUUseUJBQXlCLENBQUMsQ0FBQTtRQUMvRSxJQUFJLENBQUMsTUFBTSxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxtQkFBbUIsRUFBRSwwQkFBMEIsQ0FBQyxDQUFBO0lBQ3RGLENBQUM7SUFDTCxhQUFDO0FBQUQsQ0FBQyxBQTVDRCxJQTRDQztBQTVDWSx3QkFBTSJ9